import { useQuery } from '@tanstack/react-query';
import type { CourseDetail, CourseListResponse } from '@admitly/shared';
import { apiGet } from '../lib/api.js';

export function useCourses(category: string, subCategory: string) {
  return useQuery({
    queryKey: ['courses', category, subCategory],
    queryFn: () =>
      apiGet<CourseListResponse>(
        `/courses?category=${encodeURIComponent(category)}&subCategory=${encodeURIComponent(subCategory)}`,
      ),
    staleTime: 60_000,
  });
}

export function useCourse(courseId: string | null) {
  return useQuery({
    queryKey: ['courses', 'detail', courseId],
    queryFn: () => apiGet<{ course: CourseDetail }>(`/courses/${courseId}`),
    enabled: !!courseId,
    staleTime: 60_000,
  });
}
